import {
  keepPreviousData,
  MutationCache,
  QueryClient,
} from '@tanstack/react-query';

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: MINUTE,
      gcTime: 5 * MINUTE,
      refetchOnMount: true,
      retryOnMount: false,
      placeholderData: keepPreviousData,
    },
  },
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      switch (mutation.meta?.invalidates) {
        case 'all':
          queryClient.invalidateQueries();
      }
    },
  }),
});
